import { gql } from "graphql-tag";

export const getChallengeGQL = gql`
  query Challenges {
    challenges {
      gameId
      completedChallenges
      totalChallenges
      nextMoment {
        id
        createdAt
        updatedAt
        isCompleted
        appId
        snapshotId
        title
        description
        type
        time
        data
        timesPlayed
        showTimer
        momentType
        rankOrder
        status
        order
        zoneId
      }
    }
  }
`;

export const getContinuePlayingGQL = gql`
  query {
    continuePlaying {
      __typename
      ... on ChallengeActivity {
        gameId
        completedChallenges
        totalChallenges
        nextMoment {
          id
          title
          description
          app {
            title
          }
        }
      }
      ... on TournamentActivity {
        gameId
        tournamentId
        currentRank
      }
      ... on BeatItActivity {
        gameId
      }
    }
  }
`;
